export const fullDateLocation = 'ev-full-date-location';
export const listImagePlaceholder = 'ev-list-image-placeholder';
export const listImage = 'ev-list-image';
export const listTitle = 'list-title';
export const listItem = 'event-list-item';
export const sideBySideItem = 'side-by-side-item';
export const sideBySideItems = 'side-by-side-items';
export const cards = 'events-cards';
export const card = 'events-card';
export const image = 'image';
export const eventTitle = 'event-title';
export const singleDate = 'date-container';
export const singleImage = 'ev-image';
export const singleLocation = 'location-container';
export const rsvpButton = 'ev-rsvp-button';
export const members = 'members-avatars';
export const loadMoreButton = 'load-more-button';
export const loadingSpinner = 'loading-spinner';
export const loadMoreButtonContainer = 'load-more-button-container';
export const EVENTS_CARD = 'events-card';
export const expandedCardEventName = (id) => `expanded-card-event-name-${id}`;
export const moreInfoLink = (id) => `more-info-link-${id}`;
export const calendarCell = (timestamp) => `calendar-cell-${timestamp}`;
export const calendarCellSkeleton = 'calendar-cell-skeleton';
export const calendarDatePickerButton = 'calendar-date-picker-button';
export const calendarDatePickerLoader = 'calendar-date-picker-loader';
export const calendarCategoryPickerButton = 'calendar-category-picker-button';
export const calendarPopupCloseButton = 'calendar-popup-close-button';
export const calendarEventListItem = (eventId) => `calendar-event-list-item-${eventId}`;
export const calendarPopupBackButton = 'calendar-popup-back-button';
export const calendarEventDetails = 'calendar-event-details';
//# sourceMappingURL=widget.js.map